import { render, staticRenderFns } from "./CoursesFilter.vue?vue&type=template&id=1984ff02&"
import script from "./CoursesFilter.vue?vue&type=script&lang=js&"
export * from "./CoursesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports